(function() {
  'use strict';

  function EncomendasCtrl($state, Perfil) {
    Perfil
      .getBetaFeatures()
      .then(function (data) {
        var permissoes = data.funcionalidades;
        var feature = _.find(permissoes, function (beta) {
          return beta.codigo === 'impor_correios';
        });
        if (!feature.possuiAcesso) {
          $state.go('packages-list');
        } else {
          $state.go('lista-encomendas');
        }
      })
      .catch(function () {
        $state.go('adicionar');
      });
  }

  angular
    .module('mandaeApp')
    .controller('EncomendasCtrl', EncomendasCtrl);
})();
